<div class="row">
    <div class="col-md-12">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"><strong>Checkout</strong></h5>
            <button type="button" [mat-dialog-close]="true" class="close" data-dismiss="modal" aria-label="Close">
            <span class="close-icon" aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</div>
<div class="form-style">
    <div class="row">
        <div class="col-md-12 col-lg-12 text-center">
            <figure class="mb-0">
                <img src="/assets/img/festival/paycross.png" alt="paycross" class="paycross">
            </figure>
            <h5 class="crosspay_title">Your payment could not be completed.</h5>
        </div>
    </div>
   
    <div class="row">
        <div class="col-md-12">
            <div class="trybtn_max">
                <button type="button" class="cbse-btn" [mat-dialog-close]="true">TRY AGAIN</button>
            </div>
        </div>
    </div>
</div>
